import React from 'react';
import {
    FormControl,
    FormLabel,
    FormElement,
    FormHelperText,
    FormHeader,
    Input,
    InputGroup,
    InputSuffix,
    useFormState,
} from '@fiverr-private/forms';
import { Text } from '@fiverr-private/typography';
import { useIdentificationContext } from '@fiverr-private/identification_core';
import { translate } from '../../../utils/translate';
import { getInputStateIcon } from '../utils/getInputStateIcon';
import { FormSchema, FieldName } from './EmailIdentificationStep.schema';

interface Props {
    onChange: (value: string) => void;
    loading: boolean;
}

export const UsernameOrEmailField: React.FC<Props> = ({ loading, onChange }) => {
    const { mode } = useIdentificationContext();
    const { isValidating, errors } = useFormState<FormSchema>({ name: FieldName.usernameOrEmail });

    const icon = getInputStateIcon({
        loading: loading || isValidating,
        error: Boolean(errors.usernameOrEmail),
    });

    const isSignUpMode = mode === 'sign_up';
    const id = `identification-${FieldName.usernameOrEmail}`;

    return (
        <FormControl name={FieldName.usernameOrEmail}>
            <FormHeader>
                <FormLabel htmlFor={id}>
                    <Text fontWeight="semibold">
                        {translate(
                            isSignUpMode
                                ? 'steps.email_identification.email'
                                : 'steps.email_identification.email_or_username'
                        )}
                    </Text>
                </FormLabel>
            </FormHeader>

            <FormElement>
                <InputGroup onChange={(event) => onChange(event.target.value)}>
                    <Input id={id} placeholder="yourname@company.com" autoComplete="email" autoFocus />
                    <InputSuffix>{icon}</InputSuffix>
                </InputGroup>
            </FormElement>

            <FormHelperText />
        </FormControl>
    );
};
